import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { HISTORIC, RECSYS, SIMILARITY, TARGET_AUDIENCE } from '../../constants';

export const { Types, Creators } = createActions({
  productInit: [],
  productRequest: [],
  productSuccess: ['context', 'data'],
  productError: ['err'],
  getProducts: ['filter']
});

/** --------------------------------
 * Variable declarations
 * --------------------------------- */

const INITIAL_STATE = Immutable({
  data: [],
  [HISTORIC]: [],
  [RECSYS]: [],
  [TARGET_AUDIENCE]: [],
  [SIMILARITY]: [],
  loading: false,
  error: false
});

/* Reducers Product */

export const init = state => state.merge({ data: [] });

export const request = state => state.merge({ loading: true });

export const success = (state, { context, data }) => state.merge({ [context]: data, error: false, loading: false });

export const error = state => state.merge({ loading: false, error: true });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.PRODUCT_INIT]: init,
  [Types.PRODUCT_REQUEST]: request,
  [Types.PRODUCT_SUCCESS]: success,
  [Types.PRODUCT_ERROR]: error
});